import { shippingClient } from 'domain/HttpClients';

export const authorizeCreditCard = (payload) => shippingClient
  .Post('/api/payfort/authorize')
  .withData(payload)
  .send();
export const authorizeCreditTerm = (payload) => shippingClient
  .Post('/api/credit-management/capture')
  .withData(payload)
  .send();
